import Vue from 'vue';
import guid from '@/mixins/guid';
import axios from 'axios';

const apiUrl = process.env.VUE_APP_APIADDRESS;

export default {
    namespaced: true,
    state: {
        sessionId: null,
        timeEnteredSite: new Date(),
        timeEnteredPage: {},
        sliderInteracted: {
            retirementAge: false,
            cashLumpSum: false,
        },
        isLoggingIn: false,
        modeller: {
            currentSection: null,
            timeOnCurrentSection: 0,
        },
    },
    getters: {
        sliderInteracted: s => s.sliderInteracted,
        sessionId: s => s.sessionId,
    },
    actions: {
        init ({ dispatch, state, commit }, router) {
            commit('setSessionId', guid.methods.generateGuid());

            router.afterEach((to, from) => {
                if (state.timeEnteredPage[from.path]) {
                    dispatch('sendAnalyticsBeacon', {
                        logType: 'timeElapsed',
                        page: from.path !== '/' ? from.path.replace(/\/$/, '') : '/',
                        info: (new Date() - state.timeEnteredPage[from.path]) / 1000,
                    });
                }
                commit('setTimeEnteredPage', { page: to.path, time: new Date() });
            });

            window.addEventListener('beforeunload', () => {
                const analyticsData = {
                    logType: 'timeElapsed',
                    page: router.currentRoute.path !== '/' ? router.currentRoute.path.replace(/\/$/, '') : '/',
                    info: (new Date() - state.timeEnteredPage[router.currentRoute.path]) / 1000,
                };
                dispatch('sendAnalyticsBeacon', analyticsData);

                // send final total session time
                analyticsData.page = 'all';
                analyticsData.info = (new Date() - state.timeEnteredSite) / 1000;
                dispatch('sendAnalyticsBeacon', analyticsData);
            });


            // recording external a links opening
            document.body.onclick = (e) => {
                // eslint-disable-next-line
                e = e || event;
                // find first parent with tagName [tagname]
                function findParent (tagname, el) {
                    while (el) {
                        if ((el.nodeName || el.tagName).toLowerCase() === tagname.toLowerCase()) {
                            return el;
                        }
                        // eslint-disable-next-line no-param-reassign
                        el = el.parentNode;
                    }
                    return null;
                }
                const from = findParent('a', e.target || e.srcElement);
                if (from && from.target === '_blank') {
                    dispatch('sendAnalyticsBeacon', {
                        logType: 'linkClicked',
                        page: from.href,
                        info: new Date(),
                    });
                }
            };
        },
        sendAnalyticsBeacon ({ state, rootState }, analyticsDataJson) {
            const analyticsData = new FormData();
            analyticsData.append('logType', analyticsDataJson.logType);
            analyticsData.append('page', analyticsDataJson.page);
            analyticsData.append('sessionId', state.sessionId);

            if ((rootState.ui && rootState.ui.dashboardData && rootState.ui.dashboardData.basicData && rootState.ui.dashboardData.basicData.memberId)) {
                analyticsData.append('memberId', rootState.ui.dashboardData.basicData.memberId);
            }

            analyticsData.append('isImpersonating', !!axios.defaults.headers.get.ImpersonateId);
            analyticsData.append('info', analyticsDataJson.info);
            navigator.sendBeacon(`${apiUrl}/Log`, analyticsData);
        },
        updateModellerSection (context, modeller) {
            context.commit('setModellerSection', modeller.title);
            context.commit('setModellerTime', modeller.time);
        },
    },
    mutations: {
        setTimeEnteredPage (s, { time, page }) {
            Vue.set(s.timeEnteredPage, page, time);
        },
        setSessionId (s, value) {
            s.sessionId = value;
        },
        setSliderInteracted (s, type) {
            s.sliderInteracted[type] = true;
        },
        setLoggingIn (s) {
            s.isLoggingIn = true;
        },
        setModellerSection (s, sectionTitle) {
            s.modeller.currentSection = sectionTitle;
        },
        setModellerTime (s, time) {
            s.modeller.timeOnCurrentSection = time;
        },
    },
};
